import { render } from "./figthDiceRoll.vue?vue&type=template&id=fd0a1450&scoped=true"
import script from "./figthDiceRoll.vue?vue&type=script&lang=js"
export * from "./figthDiceRoll.vue?vue&type=script&lang=js"

import "./figthDiceRoll.vue?vue&type=style&index=0&id=fd0a1450&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd0a1450"]])

export default __exports__